import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';


const FilterPanel = ({ onFilterChange, resultCount = 0 }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [selectedContentType, setSelectedContentType] = useState('all');
  const [selectedDuration, setSelectedDuration] = useState('all');
  const [selectedLanguage, setSelectedLanguage] = useState('ru');
  const [selectedTopics, setSelectedTopics] = useState([]);

  const contentTypes = [
    { value: 'all', label: 'Все типы' },
    { value: 'live', label: 'Прямой эфир' },
    { value: 'recorded', label: 'Записи' },
    { value: 'series', label: 'Серии' }
  ];

  const durations = [
    { value: 'all', label: 'Любая длительность' },
    { value: 'short', label: 'До 15 минут' },
    { value: 'medium', label: '15-60 минут' },
    { value: 'long', label: 'Более 60 минут' }
  ];

  const languages = [
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Español' },
    { value: 'fr', label: 'Français' }
  ];

  const topics = [
    { id: 'meditation', label: 'Медитация', icon: 'Sparkles', color: 'text-accent' },
    { id: 'philosophy', label: 'Философия', icon: 'BookOpen', color: 'text-primary' },
    { id: 'travel', label: 'Путешествия', icon: 'Plane', color: 'text-secondary' },
    { id: 'music', label: 'Музыка', icon: 'Music', color: 'text-success' },
    { id: 'culture', label: 'Культура', icon: 'Palette', color: 'text-warning' },
    { id: 'science', label: 'Наука', icon: 'Atom', color: 'text-error' }
  ];

  const handleContentTypeChange = (value) => {
    setSelectedContentType(value);
    onFilterChange({ contentType: value });
  };

  const handleDurationChange = (value) => {
    setSelectedDuration(value);
    onFilterChange({ duration: value });
  };

  const handleLanguageChange = (value) => {
    setSelectedLanguage(value);
    onFilterChange({ language: value });
  };

  const handleTopicToggle = (topicId) => {
    const newTopics = selectedTopics?.includes(topicId)
      ? selectedTopics?.filter(id => id !== topicId)
      : [...selectedTopics, topicId];
    setSelectedTopics(newTopics);
    onFilterChange({ topics: newTopics });
  };

  const clearAllFilters = () => {
    setSelectedContentType('all');
    setSelectedDuration('all');
    setSelectedLanguage('ru');
    setSelectedTopics([]);
    onFilterChange({ reset: true });
  };

  const activeFilterCount = [
    selectedContentType !== 'all',
    selectedDuration !== 'all',
    selectedLanguage !== 'ru',
    selectedTopics?.length > 0
  ]?.filter(Boolean)?.length;

  return (
    <div className="filter-panel bg-card border border-border rounded-lg overflow-hidden">
      <div className="filter-header p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="p-2 rounded-lg hover:bg-muted transition-colors duration-200"
              aria-label={isExpanded ? 'Свернуть фильтры' : 'Развернуть фильтры'}
            >
              <Icon 
                name={isExpanded ? "ChevronUp" : "ChevronDown"} 
                size={20} 
                color="var(--color-foreground)" 
              />
            </button>
            <h2 className="text-lg font-heading font-semibold text-foreground">
              Фильтры
            </h2>
            {activeFilterCount > 0 && (
              <span className="px-2 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">
                {activeFilterCount}
              </span>
            )}
          </div>
          {activeFilterCount > 0 && (
            <button
              onClick={clearAllFilters}
              className="text-sm text-primary hover:text-primary/80 transition-colors duration-200"
            >
              Сбросить все
            </button>
          )}
        </div>
        <p className="text-sm text-muted-foreground mt-2">
          Найдено результатов: <span className="font-semibold text-foreground">{resultCount}</span>
        </p>
      </div>
      {isExpanded && (
        <div className="filter-content p-4 space-y-6 animate-fade-in">
          <div className="filter-section">
            <Select
              label="Тип контента"
              options={contentTypes}
              value={selectedContentType}
              onChange={handleContentTypeChange}
            />
          </div>

          <div className="filter-section">
            <Select
              label="Длительность"
              options={durations}
              value={selectedDuration}
              onChange={handleDurationChange}
            />
          </div>

          <div className="filter-section">
            <Select
              label="Язык"
              options={languages}
              value={selectedLanguage}
              onChange={handleLanguageChange}
            />
          </div>

          <div className="filter-section">
            <h3 className="text-sm font-heading font-semibold text-foreground mb-3">
              Темы
            </h3>
            <div className="topics-grid grid grid-cols-2 gap-2">
              {topics?.map((topic) => (
                <button
                  key={topic?.id}
                  onClick={() => handleTopicToggle(topic?.id)}
                  className={`topic-chip flex items-center gap-2 p-3 rounded-lg border transition-all duration-200 ${
                    selectedTopics?.includes(topic?.id)
                      ? 'border-primary bg-primary/10' :'border-border hover:border-primary/50 hover:bg-muted'
                  }`}
                >
                  <Icon 
                    name={topic?.icon} 
                    size={16} 
                    color={selectedTopics?.includes(topic?.id) ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} 
                  />
                  <span className={`text-sm font-medium ${
                    selectedTopics?.includes(topic?.id) ? 'text-primary' : 'text-foreground'
                  }`}>
                    {topic?.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;